"use client";

import * as React from "react";
import { Hexagon, Triangle, Circle, Square, Diamond, Star, Octagon, Cloud } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
const partners = [{
  id: 1,
  name: "Aether Dynamics",
  description: "Pioneering fluid motion algorithms for next-generation interfaces.",
  icon: Hexagon
}, {
  id: 2,
  name: "Lumina Corp",
  description: "Sustainable energy solutions integrated with smart grid technology.",
  icon: Triangle
}, {
  id: 3,
  name: "Orbit Systems",
  description: "Global satellite communication networks for uninterrupted connectivity.",
  icon: Circle
}, {
  id: 4,
  name: "Vanguard Tech",
  description: "Leading the charge in quantum computing and cryptography.",
  icon: Square
}, {
  id: 5,
  name: "Prism Analytics",
  description: "Deep data insights powered by advanced neural networks.",
  icon: Diamond
}, {
  id: 6,
  name: "Nova Aerospace",
  description: "Commercial spaceflight and orbital habitat development.",
  icon: Star
}, {
  id: 7,
  name: "Apex Robotics",
  description: "Autonomous systems for industrial and consumer applications.",
  icon: Octagon
}, {
  id: 8,
  name: "Nimbus Cloud",
  description: "Decentralized cloud storage with military-grade encryption.",
  icon: Cloud
}];
export default function SignaturePartnerships() {
  const [api, setApi] = React.useState<CarouselApi>();
  React.useEffect(() => {
    if (!api) return;
    const interval = setInterval(() => {
      api.scrollNext();
    }, 3500);
    return () => clearInterval(interval);
  }, [api]);
  return <section id="signature-partnerships" className="relative w-full overflow-hidden bg-background py-20">
      {}
      <div className="absolute top-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-secondary to-transparent opacity-60" />

      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-transparent via-background to-muted/10" />

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="font-default text-sm font-medium tracking-widest text-muted-foreground uppercase">
            Signature Partnerships
          </h2>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true,
        duration: 40
      }} className="w-full">
          <CarouselContent className="-ml-4 md:-ml-8 items-center">
            {partners.map((partner, i) => <CarouselItem key={partner.id} data-index={i} className="pl-4 md:pl-8 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5 xl:basis-1/6">
                <HoverCard openDelay={200} closeDelay={100}>
                  <HoverCardTrigger asChild>
                    <div className="group flex h-32 cursor-pointer items-center justify-center rounded-lg transition-all duration-500 hover:bg-muted/30">
                      <partner.icon className="h-12 w-12 text-secondary opacity-60 transition-all duration-500 group-hover:scale-110 group-hover:opacity-100 stroke-[1]" />
                    </div>
                  </HoverCardTrigger>
                  <HoverCardContent side="top" align="center" className="w-64 border-border/50 bg-card/95 p-5 shadow-2xl backdrop-blur-md">
                    <div className="space-y-2">
                      <h3 className="font-default text-base font-semibold text-card-foreground">
                        {partner.name}
                      </h3>
                      <p className="font-sans text-sm leading-relaxed text-muted-foreground">
                        {partner.description}
                      </p>
                    </div>
                  </HoverCardContent>
                </HoverCard>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>
      </div>
    </section>;
}